import React from 'react';
import {Stack} from "@mui/joy";
import Sidebar from "./components/layout/Sidebar";
import {Outlet} from "react-router-dom";
import Navbar, {NAVBAR_HEIGHT} from "./components/layout/Navbar";
import "./App.css"
import {captureReferralCode} from "./services/referral";

localStorage.setItem("joy-color-scheme-dark", "dark")
localStorage.setItem("joy-color-scheme", "dark")
localStorage.setItem("joy-mode", "dark")

// A visitor arriving on ?ref=CODE signs up much later, so the code is parked right away
captureReferralCode()

function App() {
    return <Stack height={"100%"} direction={{md: "row"}} alignItems={"center"}
                  sx={{
                      backgroundColor: "#050e1c",
                      overflow: "hidden"
                  }}>
        <Navbar/>
        <Sidebar/>
        {/* The bar is pinned over the page, so the content starts exactly below where it ends */}
        <Stack alignSelf={"center"} height={"100%"} boxSizing={"border-box"}
               paddingTop={{xs: `${NAVBAR_HEIGHT}px`, md: 0}}
               width={"100%"} flex={1} minWidth={0} sx={{overflowY: "auto", overflowX: "hidden"}} alignItems={"center"}>
            <Outlet/>
        </Stack>
    </Stack>
}

export default App;
